/* global axios */
// Integrações › Telefonia (fase 1, 25/09/2026).
import ApiClient from './ApiClient';

class TelefoniaAPI extends ApiClient {
  constructor() {
    super('telefonia', { accountScoped: true });
  }

  painel() {
    return axios.get(`${this.url}/painel`);
  }

  verificar() {
    return axios.post(`${this.url}/painel/verificar`);
  }

  criarRamal(dados) {
    return axios.post(`${this.url}/ramais`, dados);
  }

  atualizarRamal(id, dados) {
    return axios.patch(`${this.url}/ramais/${id}`, dados);
  }

  apagarRamal(id) {
    return axios.delete(`${this.url}/ramais/${id}`);
  }

  novaSenha(id) {
    return axios.post(`${this.url}/ramais/${id}/nova_senha`);
  }

  reenviar(id) {
    return axios.post(`${this.url}/ramais/${id}/reenviar`);
  }

  // Quem instala: a operadora (tronco SIP) e os números dela (etapa D)
  criarOperadora(dados) {
    return axios.post(`${this.url}/operadoras`, dados);
  }

  atualizarOperadora(id, dados) {
    return axios.patch(`${this.url}/operadoras/${id}`, dados);
  }

  apagarOperadora(id) {
    return axios.delete(`${this.url}/operadoras/${id}`);
  }

  reenviarOperadora(id) {
    return axios.post(`${this.url}/operadoras/${id}/reenviar`);
  }

  criarNumero(dados) {
    return axios.post(`${this.url}/numeros`, dados);
  }

  atualizarNumero(id, dados) {
    return axios.patch(`${this.url}/numeros/${id}`, dados);
  }

  apagarNumero(id) {
    return axios.delete(`${this.url}/numeros/${id}`);
  }

  // Filas, URAs e horários (etapa E). A URA vai como FormData (tem o áudio).
  criarFila(dados) {
    return axios.post(`${this.url}/filas`, dados);
  }

  atualizarFila(id, dados) {
    return axios.patch(`${this.url}/filas/${id}`, dados);
  }

  apagarFila(id) {
    return axios.delete(`${this.url}/filas/${id}`);
  }

  criarUra(dados) {
    return axios.post(`${this.url}/uras`, dados);
  }

  atualizarUra(id, dados) {
    return axios.patch(`${this.url}/uras/${id}`, dados);
  }

  apagarUra(id) {
    return axios.delete(`${this.url}/uras/${id}`);
  }

  criarHorario(dados) {
    return axios.post(`${this.url}/horarios`, dados);
  }

  atualizarHorario(id, dados) {
    return axios.patch(`${this.url}/horarios/${id}`, dados);
  }

  apagarHorario(id) {
    return axios.delete(`${this.url}/horarios/${id}`);
  }

  // "chegou cedo" / "fechou antes": estado forçado até uma hora
  forcarHorario(id, estado, ate) {
    return axios.post(`${this.url}/horarios/${id}/forcar`, { estado, ate });
  }

  desforcarHorario(id) {
    return axios.delete(`${this.url}/horarios/${id}/forcar`);
  }

  reenviarRoteamento() {
    return axios.post(`${this.url}/roteamento/reenviar`);
  }

  // Central telefônica (etapa F): números, ao vivo, pausa, histórico, gravação
  central(periodo = 'hoje') {
    return axios.get(`${this.url}/central`, { params: { periodo } });
  }

  aoVivo() {
    return axios.get(`${this.url}/central/ao_vivo`);
  }

  pausar(pausado, ramalId = null) {
    return axios.post(`${this.url}/central/pausa`, {
      pausado,
      ramal_id: ramalId,
    });
  }

  ligacoes(params = {}) {
    return axios.get(`${this.url}/ligacoes`, { params });
  }

  // link temporário (5 min) para ouvir ou baixar; o servidor registra o acesso
  gravacao(id, acao = 'ouvir') {
    return axios.get(`${this.url}/gravacoes/${id}`, { params: { acao } });
  }

  // Softphone: o ramal da própria pessoa, os colegas e quem está ligando.
  meuRamal() {
    return axios.get(`${this.url}/meu_ramal`);
  }

  // status da pessoa (Disponível, Almoço, Reunião, Não perturbe)
  mudarStatus(status) {
    return axios.post(`${this.url}/meu_ramal/status`, { status });
  }

  equipe() {
    return axios.get(`${this.url}/meu_ramal/equipe`);
  }

  identificar(numero) {
    return axios.get(`${this.url}/meu_ramal/identificar`, {
      params: { numero },
    });
  }
}

export default new TelefoniaAPI();
